import { authHeader, handleResponse } from "../helper/auth-header";

export default class RetailerMasterService {
  ControllerName = "RetailerMaster";

  async CreateUpdateRetailer(obj) {
    const requestOptions = {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(obj)
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/CreateUpdateRetailer`;
    const response = await fetch(url, requestOptions);
    return handleResponse(response, { url, ...requestOptions });
  }

  async GetRetailers(obj) {
    const requestOptions = {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(obj)
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetRetailers`;
    const response = await fetch(url, requestOptions);
    return handleResponse(response, { url, ...requestOptions });
  }
}
